import React from 'react';
import { useBundle } from '@amzn/react-arb-tools';
import { t, resolveContent } from 'src/utils/translation';
import { BUNDLE_NAME, LEARNING_PATHWAY_STRING_ID } from 'src/constants/localization';
import { PageHeader } from '@amzn/seller-university-ui-components';
import { LearningPathDetailData } from 'src/types/state/learningPathway';

interface LearningPathwayHeaderProps {
  title: string;
  description: string;
  imageSrc?: string;
  stats: LearningPathDetailData;
  isLocalized?: boolean;
}

const LearningPathwayPageHeader: React.FC<LearningPathwayHeaderProps> = ({
  title,
  description,
  imageSrc,
  stats,
  isLocalized = false,
}) => {
  const [learningPathwayBundle] = useBundle(
    BUNDLE_NAME.LEARNING_PATHWAY,
  );

  // Helper function to format learning path details
  const formatLearningPathDetails = (statsData: LearningPathDetailData) => {
    return {
      learningPathType: t(
        learningPathwayBundle,
        LEARNING_PATHWAY_STRING_ID.LEARNING_PATHWAY_PAGE_HEADER_PATH_TYPE,
      ),
      totalSections: t(
        learningPathwayBundle,
        LEARNING_PATHWAY_STRING_ID.LEARNING_PATHWAY_TOTAL_SECTIONS,
        { count: statsData.totalSections || 0 },
      ),
      totalModules: t(
        learningPathwayBundle,
        LEARNING_PATHWAY_STRING_ID.LEARNING_PATHWAY_TOTAL_MODULES,
        { count: statsData.totalModules ?? ((statsData.totalDocuments || 0) + (statsData.totalVideos || 0)) },
      ),
      duration: t(
        learningPathwayBundle,
        LEARNING_PATHWAY_STRING_ID.LEARNING_PATHWAY_DURATION,
        {
          minutes: Math.round((statsData.totalDuration || 0) / 60),
        },
      ),
    };
  };

  return (
    <PageHeader
      title={resolveContent(
        learningPathwayBundle,
        title,
        isLocalized,
      )}
      description={resolveContent(
        learningPathwayBundle,
        description,
        isLocalized,
      )}
      imageSrc={imageSrc}
      learningPathDetail={formatLearningPathDetails(stats)}
    />
  );
};

export default LearningPathwayPageHeader;
